var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var PassageRefTargetEditor = React.createClass({
    displayName: "PassageRefTargetEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        content: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            content: ""
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        return React.createElement(
            "div",
            null,
            "Content:",
            React.createElement("input", {
                type: "text",
                value: this.props.content,
                onChange: this.handleContentChange
            })
        );
    },

    handleContentChange: function handleContentChange(e) {
        this.change({ content: e.target.value });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = PassageRefTargetEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/passage-ref-target-editor.jsx
 ** module id = 139
 ** module chunks = 0 1
 **/